(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pgx-home-advanced"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pgx-advanced]').forEach((section) => {
    const input = section.querySelector('[data-pgx-search]');
    const results = section.querySelector('[data-pgx-suggestions]');
    let timer;
    if (input && results) {
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const term = input.value.trim();
        if (term.length < 2) { results.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
        timer = setTimeout(async () => {
          try {
            const url = `${section.dataset.searchUrl}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5`;
            const response = await fetch(url);
            const data = await response.json();
            const products = data.resources.results.products || [];
            results.replaceChildren(...products.map((item) => {
              const link = document.createElement('a'); link.className = 'pgx-suggestion'; link.href = item.url; link.setAttribute('role', 'option');
              if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.loading = 'lazy'; link.append(image); }
              const copy = document.createElement('span'); const title = document.createElement('strong'); title.textContent = item.title; copy.append(title); link.append(copy); return link;
            }));
            results.hidden = products.length === 0; input.setAttribute('aria-expanded', products.length ? 'true' : 'false');
          } catch (error) { results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
        }, 220);
      });
    }
    const recentWrap = section.querySelector('[data-pgx-recent-wrap]'); const recent = section.querySelector('[data-pgx-recent]');
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('pgxRecentlyViewed') || '[]').slice(0, 4); } catch (error) { handles = []; }
    if (recentWrap && recent && handles.length) {
      Promise.all(handles.map((handle) => fetch(`/products/${handle}.js`).then((response) => response.ok ? response.json() : null))).then((products) => {
        const cards = products.filter(Boolean).map((item) => {
          const link = document.createElement('a'); link.className = 'pgx-advanced-card'; link.href = item.url;
          if (item.featured_image) { const image = document.createElement('img'); image.className = 'pgx-advanced-card__media'; image.src = item.featured_image; image.alt = item.title; image.loading = 'lazy'; link.append(image); }
          const copy = document.createElement('span'); const title = document.createElement('strong'); title.textContent = item.title; copy.append(title); link.append(copy); return link;
        });
        if (cards.length) { recent.replaceChildren(...cards); recentWrap.hidden = false; }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgx-product-conversion"]) return;
  try {
    
  document.querySelectorAll('[data-pgx-conversion]').forEach((section) => {
    const currentHandle = section.dataset.pgxProductHandle;
    if (currentHandle) {
      try {
        const viewed = JSON.parse(localStorage.getItem('pgxRecentlyViewed') || '[]').filter((handle) => handle !== currentHandle);
        viewed.unshift(currentHandle);
        localStorage.setItem('pgxRecentlyViewed', JSON.stringify(viewed.slice(0, 8)));
      } catch (error) {}
    }
    const sticky = section.querySelector('[data-pgx-sticky-buy]');
    const variantSelect = section.querySelector('[data-pgx-sticky-variant]');
    const price = section.querySelector('[data-pgx-sticky-price]');
    const stock = section.querySelector('[data-pgx-stock]');
    const primaryForm = document.querySelector('.product-form');
    if (sticky && primaryForm && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0.08 });
      observer.observe(primaryForm);
    } else if (sticky) {
      sticky.classList.add('is-visible');
    }
    if (variantSelect && price) {
      const primaryVariant = primaryForm && primaryForm.querySelector('[name="id"]');
      const optionSelectors = primaryForm ? Array.from(primaryForm.querySelectorAll('.single-option-selector')) : [];
      const buyButton = section.querySelector('.pgx-sticky-buy__form button');
      const primaryButton = primaryForm && primaryForm.querySelector('.product-form__cart-submit');
      const primaryLabel = primaryButton && primaryButton.querySelector('[id^="AddToCartText-"]');
      const updateDetails = () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        price.textContent = option.dataset.price;
        if (buyButton) {
          buyButton.disabled = option.disabled;
          buyButton.textContent = option.disabled ? section.dataset.pgxSoldOut : section.dataset.pgxPurchaseLabel;
        }
        if (primaryButton && primaryLabel) {
          primaryButton.disabled = option.disabled;
          primaryLabel.textContent = option.disabled ? section.dataset.pgxSoldOut : section.dataset.pgxPurchaseLabel;
        }
        if (stock) {
          const inventory = Number(option.dataset.inventory);
          const showStock = !option.disabled && option.dataset.tracked === 'true' && inventory > 0 && inventory <= 5;
          stock.textContent = showStock ? section.dataset.pgxStockTemplate.replace('COUNT', inventory) : '';
          stock.hidden = !showStock;
        }
      };
      const syncFromPrimary = () => {
        const matchingOption = optionSelectors.length ? Array.from(variantSelect.options).find(option => {
          const values = JSON.parse(option.dataset.options || '[]');
          return optionSelectors.every((selector, index) => values[index] === selector.value);
        }) : null;
        if (matchingOption) {
          variantSelect.value = matchingOption.value;
        } else if (primaryVariant && Array.from(variantSelect.options).some(option => option.value === primaryVariant.value)) {
          variantSelect.value = primaryVariant.value;
        }
        updateDetails();
      };
      if (primaryForm) {
        primaryForm.addEventListener('change', () => requestAnimationFrame(syncFromPrimary));
      }
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        const values = JSON.parse(option.dataset.options || '[]');
        optionSelectors.forEach((selector, index) => {
          const value = values[index];
          if (value !== undefined && selector.value !== value) {
            selector.value = value;
            selector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        if (primaryVariant) primaryVariant.value = option.value;
        updateDetails();
      });
      syncFromPrimary();
    }
    if (sticky) {
      const sectionStyle = getComputedStyle(section);
      ['--pgx-blue', '--pgx-buy-color', '--pgx-buy-text'].forEach((name) => {
        const value = sectionStyle.getPropertyValue(name);
        if (value) sticky.style.setProperty(name, value);
      });
      document.body.appendChild(sticky);
    }
    const handLength = section.querySelector('[data-pgx-hand-length]');
    const fitResult = section.querySelector('[data-pgx-fit-result]');
    if (handLength && fitResult) {
      const sizeNames = { YS: 'Youth Small', YM: 'Youth Medium', YL: 'Youth Large', AS: 'Adult Small', AM: 'Adult Medium', AL: 'Adult Large', AXL: 'Adult XL' };
      handLength.addEventListener('change', () => {
        const size = sizeNames[handLength.value];
        fitResult.textContent = size ? `Suggested starting size: ${size}` : 'Select a measurement to see your suggested size.';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
